import { createSlice } from '@reduxjs/toolkit'
import { keyBy, sortByProp } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { SORT_DIRECTION } from '../../../../utils/common'
import { getIds } from '../helper'
import { getProvince } from './thunk'

const initialState = {
  loading: true,
  dataById: {},
  value: [],
  ids: [],
  initialIds: [],
  sortTable: {
    sortBy: '',
    sortDirection: '',
  },
}

const slice = createSlice({
  name: 'portfolioInsights/segment/portfolioProvince',
  initialState,
  reducers: {
    sort: (state, action) => {
      state.sortTable = action.payload

      if (action.payload.sortDirection) {
        state.ids = sortByProp(
          Object.values(state.dataById),
          action.payload.sortBy,
          action.payload.sortDirection === SORT_DIRECTION.DESC,
        ).map((item) => item.locationId)
      } else {
        state.ids = state.initialIds
      }
    },
    resetProvince: (state) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProvince.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getProvince.fulfilled, (state, action) => {
      state.value = action.payload
      state.dataById = keyBy(action.payload, 'locationId')
      state.ids = state.initialIds = getIds(action.payload)
      state.loading = false
    })
    builder.addCase(getProvince.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const { sort, resetProvince } = slice.actions

export const selectSegmentProvince = (callback) => (state) => {
  const data = state[slice.name].value
  return callback ? callback(data) : data
}
export const selectCellData = (id, attr) => (state) =>
  state[slice.name].dataById[id][attr]
export const selectLoading = (state) => state[slice.name].loading
export const selectIdsTable = (state) => state[slice.name].dataById
export const selectSortTable = (state) => state[slice.name].sortTable
export const selectIds = (state) => state[slice.name].ids

register(slice.name, slice.reducer)
